export default {"src":"/_next/static/media/OURSONG.11231b8b.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};